// extracted by mini-css-extract-plugin
export default {"container":"xm","overlay":"ym","videoOverlay":"zm","withHeader":"Am","header":"Bm","close":"Cm","content":"Dm"};